import * as React from 'react';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';
import InstructionsCore from './InstructionsCore';
import { UserRoleEnum } from '../../redux/UserSlice';

const Instructions = (props: any) => {
    const isAdminUser: boolean = useAppSelector(isAdmin);

    return (
        <React.Fragment>
            <InstructionsCore userRole={UserRoleEnum.EntityUser} dataSection="Instructions" />
        </React.Fragment>
    );
}

export default Instructions;